let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5sFLQ")).then(() => parcelRequire('5eKjD'));